import { SwitchField } from "common";
import { useFormikContext } from "formik";
import React from "react";
import { CheckInValidation } from "types";
import { PurchaseCutoffScheduleInput } from "@/components/Product/ExperienceCheckIn/CheckInWindow/PurchaseCutoffScheduleInput";
import { ExperienceCheckInFormValues } from "@/components/Product/ExperienceCheckIn/ExperienceCheckIn.types";

interface CheckInWindowFieldProps {
    disabled?: boolean;
    requireGuestIdentification?: boolean;
    value: CheckInValidation[];
}

export const CheckInWindowField = ({ disabled, requireGuestIdentification, value }: CheckInWindowFieldProps) => {
    const { values, setFieldValue } = useFormikContext<ExperienceCheckInFormValues>();

    const isEnabled = requireGuestIdentification ? !!values.checkInPreference?.checkInWindowEnabled : false;

    const handleEnabledToggle = (checked: boolean) => {
        setFieldValue("checkInPreference.checkInWindowEnabled", checked);
    };

    return (
        <div className="mb-2">
            <SwitchField
                isChecked={isEnabled}
                isDisabled={disabled}
                data-testid="check-in-window"
                onChange={handleEnabledToggle}
            >
                All guests must check-in within a limited window
            </SwitchField>

            {isEnabled && <PurchaseCutoffScheduleInput validations={value} />}
        </div>
    );
};
